export default "__VITE_ASSET__BnOexxgj__"